<template>
  <div class="main">
    <div class="wrapPortable wrapAccueil">
      <h1 class="main-h1">
          BONJOUR {{ user.prenom }}
      </h1>
      </div>
      <ul class="accueil">
        <div :class="[user.coach == true ? 'masqueCoach' : '', 'masqueAcueil']">
          <li class="li-accueil debut" v-if="user.coach == true">
              <router-link to="/session_co" title="Session collective" class="a-accueil">
                Débuter une session collective <p class="section-p2"><img src="../assets/logo/logo-collective.png" class="puce-accueil debut" alt="logo althère"></p>
              </router-link>
          </li>
          <li :class="[user.coach !== true ? 'debut' : '', 'li-accueil']">
              <router-link to="/session" title="Session individuel" class="a-accueil">
                Débuter une session <p class="section-p2"><img src="../assets/logo/picto-cercle_NouvelleSession_blanc.png" class="puce-accueil debut" alt="logo althère"></p>
              </router-link>
          </li>
          <li class="li-accueil">
              <router-link to="/statistiques" title="Statistiques" class="a-accueil">
                Mes statistiques <p class="section-p2"><img src="../assets/logo/picto-cercle_Resultats_blanc.png" class="puce-accueil" alt="logo loupe"></p>
              </router-link>
          </li>
          <li class="li-accueil">
                <router-link to="/test" title="Test" class="a-accueil">
                    Réévaluer mon niveau <p class="section-p2"><img src="../assets/logo/picto-cercle_Reevaluation_blanc.png" class="puce-accueil" alt="logo crayon"></p>
                </router-link>
          </li>
          <li class="li-accueil fin">
              <router-link to="/exercices_favories" title="Favories" class="a-accueil">
                Mes exercices <p class="section-p2"><img src="../assets/logo/picto-cercle_Exercices_blanc.png" class="puce-accueil" alt="logo photo"></p>
              </router-link>
          </li>
          <li class="li-accueil fin" v-if="user.coach == true">
              <router-link to="/mes_cours" title="Favories" class="a-accueil">
                Consulter mes cours <p class="section-p2"><img src="../assets/logo/picto-cercle_Exercices_blanc.png" class="puce-accueil" alt="logo photo"></p>
              </router-link>
          </li>
          </div>
      </ul>
  </div>
</template>

<script>
import { User } from "../controller/user.js"
import * as controle from "@/controller/correctionEcran.js";
import screenfull from "screenfull";

export default {
  name: "Accueil",
  data() {
    return {
        user: JSON.parse(localStorage.user)|| [],
    };
  },
  beforeRouteEnter (to, from, next) {
    try {
        JSON.parse(localStorage.user);
        let user = JSON.parse(localStorage.user);
        if (user.prenom == 'demo' && user.nom == 'demo'){
          next('/connexion');
        }else{
          next();
        }
      } catch (error) {
        next('/connexion');
      } 
  },
  created() {
    
    
      
    if (typeof(localStorage.user) !== undefined && localStorage.length > 1 ){
      try {
        JSON.parse(localStorage.user);
        this.user = JSON.parse(localStorage.user);
        //console.log(this.user.nom);
      } catch (error) {
        this.$router.push({ name: 'connexion' });
      }
    }
  },
    
};
</script>



// WEBPACK FOOTER //
// src/components/Accueil.vue